// Updated OpenAI service to use backend API endpoints instead of direct calls

export const translateLyrics = async (lyrics: string, targetLanguage: string): Promise<string> => {
  try {
    const response = await fetch('/api/translate-lyrics', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ lyrics, targetLanguage }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Translation failed');
    }

    const data = await response.json();
    return data.translation;
  } catch (error: any) {
    console.error('Error translating lyrics:', error);
    
    if (error.message.includes('fetch')) {
      throw new Error('Network error. Please check your connection and try again.');
    } else {
      throw new Error(error.message || 'Failed to translate lyrics');
    }
  }
};

export const generateVocabulary = async (lyrics: string, language: string): Promise<any> => {
  try {
    const response = await fetch('/api/generate-vocabulary', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ lyrics, language }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Vocabulary generation failed');
    }

    const data = await response.json();
    return data.vocabulary;
  } catch (error: any) {
    console.error('Error generating vocabulary:', error);
    
    if (error.message.includes('fetch')) {
      throw new Error('Network error. Please check your connection and try again.');
    } else {
      throw new Error(error.message || 'Failed to generate vocabulary');
    }
  }
};

export const generateLyrics = async (prompt: string): Promise<string> => {
  try {
    const response = await fetch('/api/generate-lyrics', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prompt }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Lyrics generation failed');
    }

    const data = await response.json();
    return data.lyrics;
  } catch (error: any) {
    console.error('Error generating lyrics:', error);
    
    if (error.message.includes('fetch')) {
      throw new Error('Network error. Please check your connection and try again.');
    } else {
      throw new Error(error.message || 'Failed to generate lyrics');
    }
  }
};